import { render, staticRenderFns } from "./UserProfileCard.vue?vue&type=template&id=37032358&scoped=true"
import script from "./UserProfileCard.vue?vue&type=script&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&lang=js"
import style0 from "./UserProfileCard.vue?vue&type=style&index=0&id=37032358&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37032358",
  null
  
)

export default component.exports